<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group class="float-right">
        <el-button v-if="HissedarDurum" type="danger" size="small" class="YeniBtn" @click="HissedarMahsup">
          Hisse Mahsuplaştır
        </el-button>
        <el-button type="success" size="small" v-if="Yetki" class="YeniBtn" @click="YeniBtn">
          Kişi Ekle
        </el-button>
        <el-button type="primary" size="small" v-if="Yetki" class="YeniBtn" @click="Duzenle">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="20">
          <table v-if="MeskenListe" class="table table-hover table-sm">
            <thead>
            <tr>
              <th>Ad Soyad</th>
              <th>Mülk</th>
              <th>Telefon</th>
              <th>Giriş Tarihi</th>
              <th>Çıkış Tarihi</th>
              <th width="150"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="Kisi in MeskenListe">
              <td>{{ Kisi.AdSoyad }}</td>
              <td>{{ Kisi.SahipText }}</td>
              <td>{{ Kisi.Telefon }}</td>
              <td>{{ Kisi.gTarihiText }}</td>
              <td>{{ Kisi.cTarihiText }}</td>
              <td class="text-right">
                <el-button-group>
                  <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                              placement="top-start">
                    <i
                      class="feather-edit-2  tableibtn text-primary"
                      @click="DuzenleBtn(Kisi)">
                    </i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="Kişi Ekran" placement="top-start">
                    <i
                      class="feather-airplay tableibtn text-success"
                      @click="$router.push('/yonetim/kisi/'+Kisi.Kisi_id)">
                    </i>
                  </el-tooltip>
                  <el-tooltip v-if="Kisi.Silinebilir && Yetki" class="item" effect="dark" content="Sil"
                              placement="top-start">
                    <i
                      class="feather-trash tableibtn text-danger"
                      @click="SilOnay(Kisi.Kisi_id)">
                    </i>
                  </el-tooltip>
                </el-button-group>
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
        <el-col :span="4">
          <BilgiKutu v-if="BilgiKutu" :data="BilgiKutu"></BilgiKutu>
          <Notlar v-if="Notlar.Modul_id" :data="Notlar"></Notlar>
        </el-col>
      </el-row>
    </div>
    <MeskenDetay :data="Form" :ModalOlayi="ModalOlayi" @ModalOlayi="SayfaYukle"></MeskenDetay>
    <FormModal v-if="Yetki" :data="FormData" :ModalOlayi="kModalOlayi" :Mesken="Mesken_id"
               @ModalOlayi="SayfaYukle"></FormModal>
  </div>
</template>
<script>

import MeskenDetay from "../../../components/Pack/Yonetim/mesken/MeskenDetay";
import Notlar from "../../../components/Pack/Genel/Notlar";
import FormModal from "../../../components/Pack/Yonetim/kisi/FormModal";
import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
import MeskenHisseModal from "../../../components/Pack/Yonetim/mesken/MeskenHisseModal";

export default {
  props: ["Mesken_id"],
  components: {MeskenHisseModal, BilgiKutu, FormModal, Notlar, MeskenDetay},
  data() {
    return {
      MeskenHisseModalDurum: false,
      HissedarDurum: false,
      BilgiKutu: null,
      Notlar: {
        Modul: 'Mesken',
        Modul_id: this.Mesken_id
      },
      Sayfa: {
        Adi: 'Mesken Ekran'
      },
      Yetki: null,
      ModalOlayi: false,
      kModalOlayi: false,
      Form: {
        Baslik: 'Mesken Düzenle'
      },
      FormData: {
        Baslik: 'Kişi Ekle'
      },
      MeskenListe: []
    }
  },
  methods: {
    HissedarMahsup() {
      this.$store.dispatch("Get", {path: 'spesiyal/hissedar/' + this.Mesken_id})
        .then(response => {
          this.$message.success("Hissedar mahsuplaşma çalıştırıldı.")
        })
    },
    SayfaYukle() {
      this.ModalOlayi = false;
      this.kModalOlayi = false;
      this.$store.dispatch("Get", {path: 'yonetim/mesken/d/' + this.Mesken_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.HissedarDurum = response.HissedarDurum;
            this.Form = response.Bilgi;
            this.Form.Baslik = 'Mesken Düzenle';
            this.BilgiKutu = {
              Baslik: 'Mesken Bilgi',
              Detay: [
                {Baslik: 'Kat / No', Bilgi: this.Form.Kat + ' / ' + this.Form.kNo, Ikon: 'flaticon-background'},
                {Baslik: 'Tanim', Bilgi: this.Form.Tanim, Ikon: 'flaticon-background'},
                {Baslik: 'm2', Bilgi: this.Form.m2, Ikon: 'flaticon-background'},
                {Baslik: 'Bina Adı', Bilgi: this.Form.BinaAdi, Ikon: 'flaticon-buildings',},
                {
                  Baslik: 'Adres',
                  Bilgi: this.Form.BinaAdres + ' ' + this.Form.label + ' - ' + this.Form.BinaSehir,
                  Ikon: 'flaticon2-maps',
                },
              ]
            }
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/m/' + this.Mesken_id})
        .then(response => {
          if (response.Durum === 'OK') {

            //this.Form = response.Bilgi;
            this.MeskenListe = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });


    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/kisi/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    Duzenle() {
      this.Form.Baslik = 'Mesken Düzenle';
      this.ModalOlayi = true;
    },
    YeniBtn() {
      this.kModalOlayi = true;
      this.FormData = {
        Baslik: 'Yeni Kişi Ekle',
        AdSoyad: null,
        Telefon: null,
        aKodu: "90",
        Mail: null,
        vDaire: null,
        vNo: null,
        dTarihi: null,
        Sahip: null,
        gTarihi: null,
        cTarihi: null,
        oOdeme: true,
        Kisi_id: null,
        KB_id: null,
        Mesken_id: this.Mesken_id,
        Bilgi: {},
        IndirimListe: [],

      }
    },
    DuzenleBtn(Veri) {
      this.kModalOlayi = true;
      this.FormData = Veri;
      this.FormData.Baslik = Veri.AdSoyad + ' Düzenle'
    },
  },
  created() {
    this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
    this.SayfaYukle();


  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/mesken/Detay.vue